import React, { Children, Fragment } from 'react';
import { AwesomeComponent, ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { array, arrayOf, element, list, object, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { ExperimentalFlagsService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { getLostProps, isObject, propagateData, propagateProps } from '@philips-internal/oswald-ui-utils';
import { SpreaderAPI } from './spreader-api.js';
function spread(source, entries) {
    if (Array.isArray(source) || !isObject(source) || !entries || entries.length === 0) {
        return {};
    }
    const result = {};
    for (const entry of entries) {
        if (entry in source) {
            result[entry] = source[entry];
        }
    }
    return result;
}
function spreadData(props, lostProps) {
    const data = spread(props.data, props.entries);
    return propagateData(props.children, props.data, { ...lostProps, ...data });
}
function spreadValue(props, lostProps) {
    const data = spread(props.value ?? Spreader.defaultProps.value, props.entries);
    return propagateProps(props.children, { ...lostProps, ...data });
}
const SpreaderContainer = {
    name: '',
};
function Spreader(props) {
    if (Children.count(props.children) === 0) {
        return React.createElement(Container, { className: "u-expand", uuid: props.uuid });
    }
    const lostProps = getLostProps(Spreader.propTypes, props);
    const fn = ExperimentalFlagsService.getSpreaderConsiderValueInsteadOfData()
        ? spreadValue
        : spreadData;
    return (React.createElement(Fragment, null, fn(props, lostProps)));
}
Spreader.propTypes = {
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    data: oneOfType([object, array]).notEnumerable(),
    entries: list,
    uuid: string,
    value: oneOfType([object, array]).notEnumerable(),
};
Spreader.defaultProps = {
    data: {},
    entries: [],
    value: {},
};
const awesomeProps = {
    api: SpreaderAPI,
    containers: [SpreaderContainer],
    type: ComponentType.BEHAVIOR,
};
AwesomeComponent(awesomeProps)(Spreader);
export { Spreader, };
//# sourceMappingURL=spreader.js.map